"use strict";

const UP = 'up';
const DOWN = 'down';

/**
 * Class AutoCollapse
 *
 * Html like:
 *
 *      <div data-auto-collapse="text" id="seo">
 *          <h1>header title</h1>
 *          <p>
 *              adasdads asd asdaaasasasd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd1
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd2
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd3
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd4
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd5
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd6
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd7
 *
 *          </p>
 *          <h2>title 1</h2>
 *          <p>
 *              adasdads asd asasasd asd aasd ssd asdasdasd asd asdasd asdasd asdasd asdasdasasd8
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd9
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd10
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd11
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd12
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd13
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd14
 *
 *          </p>
 *          <blockquote>block quote for title 1</blockquote>
 *          <h4>title 2</h4>
 *          <video>video for title 2</video>
 *          <a>link for title 2</a>
 *          <p>text for title 2</p>
 *          <ul><li>list for title 2</li></ul>
 *      </div>
 *
 * And Javascript like:
 *
 *      require('bootstrap/js/dist/collapse');
 *      import AutoCollapse from '/path/to/autoCollapseText';
 *      new AutoCollapse({
 *          'container': '#seo',
 *      });
 *
 * Is automatically converted to bootstrap collapse html:
 *
 *      <div id="seo" class="auto-collapse-text auto-collapse-text--accordion">
 *          <h1 class="auto-collapse-text__nch auto-collapse-text__nch-0">header title</h1>
 *          <p>
 *              adasdads asd asdaaasasasd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd1
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd2
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd3
 *              asd asd asd as dasd as dd asd asd asdasdasd asd asdasd<span class="ellipsis"> ...</span>
 *          </p>
 *          <div class="auto-collapse-text__item auto-collapse-text__item-0 auto-collapse-text__item-first">
 *              <button class="auto-collapse-text__button auto-collapse-text__button--bottom collapsed"
 *                      type="button"
 *                      aria-expanded="true"
 *                      aria-controls="seocollapse0"
 *                      data-toggle="collapse"
 *                      data-target="#seocollapse0"
 *              >
 *                  <span class="auto-collapse-text__button__collapse-text">lees meer</span>
 *                  <span class="auto-collapse-text__button__expand-text">lees minder</span>
 *                  <i class="fas fa-chevron-down"></i>
 *              </button>
 *              <div id="seocollapse0"
 *                   class="auto-collapse-text__content collapse show"
 *              >
 *                  <p>
 *                      asdasd asdasd asdasdasasd4
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd5
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd6
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd7
 *                  </p>
 *                  <p>
 *                      adasdads asd asasasd asd aasd ssd asdasdasd asd asdasd asdasd asdasd asdasdasasd8
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd9
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd10
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd11
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd12
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd13
 *                      asd asd asd as dasd as dd asd asd asdasdasd asd asdasd asdasd asdasd asdasdasasd14
 *                  </p>
 *                  <blockquote>block quote for title 1</blockquote>
 *                  <h4>title 2</h4>
 *                  <video>video for title 2</video>
 *                  <a>link for title 2</a>
 *                  <p>text for title 2</p>
 *                  <ul><li>list for title 2</li></ul>
 *              </div>
 *          </div>
 *      </div>
 *
 * This html allows bootstrap collapse to work. See: https://getbootstrap.com/docs/4.0/components/collapse/
 * This code is only compatible with bootstrap 3 and 4
 */
export default class autoCollapseText {

    /**
     * Constructor
     *
     * @param {string|Element} container    Container path or node where the auto-collapse-text functionality has to operate. Example: '.path .to #container'
     *                                      Default container path is "data-auto-collapse='text'"
     * @param {boolean} expand              Expand collapsible container at initiation
     * @param {int}     totalWords          Total words until collapse has to occur
     * @param {boolean} showEllipsis        Show ellipsis '...' at the end of the text
     * @param {string}  buttonTextCollapsed Button text when content is collapsed
     * @param {string}  buttonTextExpanded  Button text when content is expanded
     * @param {string}  buttonPlacement     Button placement. Allowable values: 'bottom' or 'top'
     * @param {int}     fontAwesomeVersion  Font Awesome Version currently installed in project. Accepted values: 4 and 5.
     * @param {string}  breakpointUp        Only activate auto-collapse-text when window width is "larger than" bootstrap breakpoint value. Accepted bootstrap breakpoints are: 'xs', 'sm', 'md', 'lg' and 'xl'. This feature is disabled when value is undefined.
     * @param {string}  breakpointDown      Only activate auto-collapse-text when window width is "smaller than" bootstrap breakpoint value. Accepted bootstrap breakpoints are: 'xs', 'sm', 'md', 'lg' and 'xl'. This feature is disabled when value is undefined.
     */
    constructor({
        container,
        expand = false,
        totalWords = 45,
        showEllipsis = true,
        buttonTextCollapsed = 'Lees meer',
        buttonTextExpanded = 'Lees minder',
        buttonPlacement = 'bottom',
        fontAwesomeVersion = 5,
        breakpointUp = undefined,
        breakpointDown = undefined,
    }) {
        this.config = {
            container,
            expand,
            totalWords,
            showEllipsis,
            buttonTextCollapsed,
            buttonTextExpanded,
            buttonPlacement,
            fontAwesomeVersion,
            breakpointUp,
            breakpointDown,
        }

        // Bootstrap Breakpoints
        this.bootstrapBreakpoints = {
            xs: 0,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        };

        // classes according to BEM naming guide: http://getbem.com/naming/
        this.classes = {
            base: 'auto-collapse-text',
            modifier: {
                collapsed: 'auto-collapse-text--collapsed',
            },
            element: {
                item: 'auto-collapse-text__item',
                button: 'auto-collapse-text__button',
                buttonTextExpanded: 'auto-collapse-text__button__collapse-text',
                buttonTextCollapsed: 'auto-collapse-text__button__expand-text',
                content: 'auto-collapse-text__content'
            },
        }

        this.buildAutoCollapse();
    }

    /**
     * Build Automatic Collapse
     */
    buildAutoCollapse() {
        if (undefined !== this.config.breakpointUp && false === this.renderAtBreakpoint(this.config.breakpointUp, UP)) return;
        if (undefined !== this.config.breakpointDown && false === this.renderAtBreakpoint(this.config.breakpointDown, DOWN)) return;

        const containers = 'object' === typeof this.config.container ? [this.config.container] : document.querySelectorAll(this.config.container ?? '[data-auto-collapse="tags"]');
        containers.forEach((container, index) => {
            const globalIdName = '' !== container.id ? container.id : container.className.replace(/[&\s\/\\#\[\],=+\-()$~%.'":*?<>{}]/g, '');

            // prevent rebuild of autoCollapse if autoCollapse already exists
            if (0 < container.getElementsByClassName(this.classes.element.button).length) {
                return;
            }

            const pTags = container.querySelectorAll('p');
            let counter = 0;

            // wrapper
            container.classList.add(this.classes.base);
            if (false === this.config.expand) container.classList.add(this.classes.modifier.collapsed);

            // create unique id;
            this.idName = (() => {
                if ('' === container.id) {
                    container.id =  globalIdName + index;
                    return globalIdName + index;
                } else {
                    return container.id;
                }
            }) ();
            this.localId = this.idName + 'collapse' + index;

            for (const pTag of pTags) {
                const pSplit = pTag.textContent.trim().split(' ');
                const pLength = pSplit.length;

                if ((counter + pLength) >= this.config.totalWords) {
                    const pSplitAtWords = this.config.totalWords - counter;

                    // split first half of p content
                    let pTagClone1 = pTag.cloneNode(false);
                    pTagClone1.classList.add(this.classes.base + '__split');
                    pTagClone1.innerHTML = pSplit.slice(0, pSplitAtWords).join(' ') + (true === this.config.showEllipsis ? '<span class="ellipsis">...</span>' : '');

                    // split second half of p content
                    let pTagClone2 = pTag.cloneNode(false);
                    pTagClone2.innerHTML = pSplit.slice(pSplitAtWords).join(' ');

                    // create bootstrap item
                    let bootstrapItem = this.createItem(index);

                    // create bootstrap button
                    bootstrapItem.appendChild(this.createButton());

                    // create bootstrap content
                    let bootstrapContent = this.createContent(pTag);
                    bootstrapContent.insertBefore(pTagClone2, bootstrapContent.firstChild);
                    bootstrapItem.appendChild(bootstrapContent);

                    // place new html in template
                    pTag.parentNode.insertBefore(bootstrapItem, pTag.nextSibling);
                    pTag.replaceWith(pTagClone1);

                    break;
                }

                counter += pLength;
            }

            this.eventListener(container);
        })
    }

    /**
     * Create Collapsible Item
     *
     * @param {int} index      x item in array
     *
     * @returns {HTMLDivElement}
     */
    createItem(index) {
        let bootstrapItem = document.createElement('div');
        bootstrapItem.classList.add(this.classes.element.item, this.classes.element.item + '-' + index);

        return bootstrapItem;
    }

    /**
     * Create Collapsible Button
     *
     * @returns {HTMLButtonElement}
     */
    createButton() {
        let bootstrapButton = document.createElement('button');
        bootstrapButton.classList.add(this.classes.element.button, this.classes.element.button + '--' + this.config.buttonPlacement, 'btn');

        let bootstrapButtonTextExpand = document.createElement('span');
        bootstrapButtonTextExpand.classList.add(this.classes.element.buttonTextExpanded);
        bootstrapButtonTextExpand.innerText = this.config.buttonTextCollapsed;

        let bootstrapButtonTextCollapse = document.createElement('span');
        bootstrapButtonTextCollapse.classList.add(this.classes.element.buttonTextCollapsed);
        bootstrapButtonTextCollapse.innerText = this.config.buttonTextExpanded;

        bootstrapButton.setAttribute('type', 'button');
        bootstrapButton.setAttribute('aria-expanded', true === this.config.expand ? 'true' : 'false');
        bootstrapButton.setAttribute('aria-controls', this.localId);
        bootstrapButton.setAttribute('data-toggle', 'collapse');
        bootstrapButton.setAttribute('data-target', '#' + this.localId);

        bootstrapButton.appendChild(bootstrapButtonTextExpand);
        bootstrapButton.appendChild(bootstrapButtonTextCollapse);
        bootstrapButton.appendChild(this.createChevronIcon());

        return bootstrapButton;
    }

    /**
     * Create Fontawesome Chevron Icon
     *
     * @returns {HTMLElement}
     */
    createChevronIcon() {
        let chevronIcon = document.createElement('i');
        switch(this.config.fontAwesomeVersion) {
            case 4:
                chevronIcon.classList.add('fa', 'fa-chevron-down');
                break;
            case 5:
                chevronIcon.classList.add('fas', 'fa-chevron-down');
                break;
        }

        return chevronIcon;
    }

    /**
     * Create Collapsible Content Element
     *
     * @param {object} node     node where the siblings of this node creates the content
     *
     * @returns {HTMLDivElement}
     */
    createContent(node) {
        let bootstrapContent = document.createElement('div');
        bootstrapContent.id = this.localId;
        bootstrapContent.classList.add(this.classes.element.content, 'collapse');
        if (true === this.config.expand) bootstrapContent.classList.add('show');

        let nextNode = node;
        let nextNodes = [];
        while (
            null !== nextNode &&
            (nextNode = nextNode.nextElementSibling)
        ) {
            nextNodes.push(nextNode);
        }

        nextNodes.forEach(nextNodeEl => {
            bootstrapContent.appendChild(nextNodeEl);
        })

        return bootstrapContent;
    }

    /**
     * Decide if auto-collapse-text should work based on breakpoint
     *
     * @param {string} breakpoint   Breakpoint value. Accepted values: 'xs', 'sm', 'md', 'lg' and 'xl'
     * @param {string} upOrDown     Breakpoint Up or Down: Accepted values: 'up' and 'down'
     *
     * @returns {boolean}
     */
    renderAtBreakpoint(breakpoint, upOrDown) {
        const windowWidth = window.innerWidth ?? document.documentElement.clientWidth ?? document.body.clientWidth;

        if ('undefined' === this.bootstrapBreakpoints[breakpoint]) {
            console.error('unknown key ' + breakpoint + ' in array this.bootstrapBreakpoints');

            return false;
        }

        return (
            (DOWN === upOrDown && this.bootstrapBreakpoints[breakpoint] > windowWidth) ||
            (UP === upOrDown && this.bootstrapBreakpoints[breakpoint] < windowWidth)
        );
    }

    /**
     * EventListener. Listens to click event of collapsible button
     *
     * @param container wrapper
     */
    eventListener(container) {
        const button = container.getElementsByClassName(this.classes.element.button);

        // prevent listener when button does not exist.
        if (0 === button.length) {
            return;
        }

        button[0].addEventListener('click', event => {
            this.toggleClassWrapper(container);
        });
    }

    /**
     * Add collapsed class in wrapper when content is collapsed.
     *
     * @param container wrapper
     */
    toggleClassWrapper(container) {
        'true' === event.currentTarget.getAttribute('aria-expanded') ?
            container.classList.add(this.classes.modifier.collapsed) :
            container.classList.remove(this.classes.modifier.collapsed)
        ;
    }
}
